import {AbstractControl, ValidationErrors} from '@angular/forms';
import * as moment from 'moment';
import {CensusesData} from '../../../../shared/types/nso-data-portal/census-data';

export function checkDateValidation(control: AbstractControl): ValidationErrors | null {

  if (control.value && this.censuses) {
    const actual = control.value;

    return this.censuses
      .filter(entry => entry.year !== actual.year)
      .find((census: CensusesData) => {
        return moment(census.startDate).isSameOrBefore(actual.endDate) &&
          moment(census.endDate).isSameOrAfter(actual.startDate);
      }) ? {'dateOverlapping': {value: control.value}} : null;
  }

  return null;
}
